module.exports = __webpack_public_path__ + "assets/grinning_squinting_face.45c3f8554905aee35252c7f64d7b5893.png";